import React from 'react';

const Divider = ({ 
    orientation = 'horizontal', 
    color = '#dee2e6', 
    thickness = '1px', 
    margin = '1rem 0',
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className 
}) => {
    const isHorizontal = orientation === 'horizontal';
    
    return (
        <hr 
            className={className} 
            style={{ 
                width: isHorizontal ? '100%' : thickness,
                height: isHorizontal ? thickness : '100%',
                backgroundColor: color,
                border: 'none',
                margin: margin,
                ...style 
            }} 
        />
    );
};

export default Divider;

